export const siteName = "瓜爆观察";

export interface TrendItem {
  tag: string;
  title: string;
  desc: string;
  heat: string;
}

export const navLinks = [
  { label: "正在关注", href: "#watch" },
  { label: "为何会爆", href: "#blast" },
  { label: "连锁反应", href: "#chain" },
  { label: "波及面", href: "#ripple" },
  { label: "余波演变", href: "#lifecycle" },
  { label: "理性吃瓜", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export const watchIntro =
  "热点不是凭空爆发的。它们往往先在一个圈层里积蓄能量，再被某个节点引爆。我们持续跟踪不同类型事件从“发酵”到“爆发”再到“蔓延”的共同规律，帮你在纷乱的信息流里看清脉络。";

export const watchTrends: TrendItem[] = [
  {
    tag: "娱乐八卦",
    title: "明星私域信息外泄",
    desc: "当个人聊天截图与录音流入公共舆论场，私人情绪如何被放大为公共议题。",
    heat: "爆点密集",
  },
  {
    tag: "行业舆情",
    title: "头部品牌“翻车”",
    desc: "从客服回应到公关声明，每一句话都可能成为下一轮扩散的燃料。",
    heat: "持续发酵",
  },
  {
    tag: "公共话题",
    title: "职场薪酬之争",
    desc: "收入数字一旦公开，便天然自带情绪张力，极易引发阵营式站队。",
    heat: "破圈传播",
  },
  {
    tag: "平台热点",
    title: "短剧与热梗刷屏",
    desc: "内容浓度越高，二次创作越旺盛，一个梗能在几小时内多平台开花。",
    heat: "指数增长",
  },
];

export interface MechanismItem {
  no: string;
  title: string;
  icon: string;
  body: string;
  point: string;
}

export const mechanismList: MechanismItem[] = [
  {
    no: "01",
    title: "信息裂变",
    icon: "ri-node-tree",
    body: "一条内容从“转发给一个人”到“转发给一千个人”，关键不在于它多劲爆，而在于它是否容易“一句话讲清楚”并激起转发冲动。越难被转述的信息，越难爆发。",
    point: "可转发性决定扩散半径",
  },
  {
    no: "02",
    title: "情绪共振",
    icon: "ri-fire-line",
    body: "愤怒、猎奇、共鸣、反差是四大引擎。当内容戳中多数人心里共同的那根弦，点赞与评论就会像共鸣腔一样彼此叠加，形成越吵越热的正反馈。",
    point: "情绪是流量的燃料",
  },
  {
    no: "03",
    title: "节点放大",
    icon: "ri-radio-2-line",
    body: "大号转载、媒体跟进、平台推荐位，是三个不同的放大器。真正的“爆”，往往是三个放大器同时按下，把原本圈层内的事件一次性推到公共视野。",
    point: "放大器共振才有总攻",
  },
  {
    no: "04",
    title: "信息缺口",
    icon: "ri-question-line",
    body: "越关键的信息越被遮掩，外界的猜测就越旺盛。信息缺口就像吸尘器，会自动把注意力、追问和谣言一并吸进来，直到真相或新的热点填满它。",
    point: "悬念本身就在喂养热度",
  },
];

export interface ChainStep {
  title: string;
  body: string;
}

export const chainIntro =
  "爆发只是开始。真正漫长的，是事件像多米诺骨牌一样在时间轴上不断倒下：当事人回应、关联方表态、行业被牵连、旧账被翻出……我们把这套“牵一发而动全身”的过程拆成四个阶段。";

export const chainSteps: ChainStep[] = [
  {
    title: "圈层渗透",
    body: "事件先从最贴近信源的圈层（粉丝、同行、利益相关方）出发，向泛娱乐、职场、生活等外围圈层渗透，每跨一层，语境就被改写一次。",
  },
  {
    title: "正反共振",
    body: "支持者与反对者围绕同一素材展开辩论，双方每轮交锋都为热度续命。正反观点的对立越清晰，话题的生命周期就越长。",
  },
  {
    title: "二次发酵",
    body: "考古翻旧账、二创玩梗、当事人下场回应，都可能让一个接近降温的事件重新回热，形成“爆—平—再爆”的波浪曲线。",
  },
  {
    title: "规则清算",
    body: "当热度累积到一定程度，相关方会被迫回应、道歉、整改甚至追责，舆论对“结论与交代”的期待随之成为下一阶段的主线。",
  },
];

export interface RippleRing {
  key: string;
  label: string;
  color: string;
  who: string;
  body: string;
  impact: string;
}

export const rippleRings: RippleRing[] = [
  {
    key: "party",
    label: "当事人核心圈",
    color: "bg-primary-500",
    who: "当事人 · 团队 · 最亲近关联者",
    body: "处于风暴正中心，直接影响名誉、关系与事业走向。回应时机、语气与真实性，往往决定第一波走势。",
    impact: "直接影响最大，但口径可由自己控制",
  },
  {
    key: "affiliate",
    label: "关联与利益方",
    color: "bg-accent-500",
    who: "合作方 · 同行 · 上下游机构",
    body: "因站位而被迫表态：切割、观望或站队。每一个决定都会被放到聚光灯下审视，稍有迟疑便可能引火烧身。",
    impact: "卷入面广，话语空间收窄",
  },
  {
    key: "industry",
    label: "行业与平台",
    color: "bg-secondary-500",
    who: "所在行业 · 内容平台 · 监管框架",
    body: "个案常被放大为行业通病的证据，促使平台调整规则、行业重估潜规则，甚至催生新的治理与规范讨论。",
    impact: "从个案上升为结构与规则议题",
  },
  {
    key: "public",
    label: "公众舆论场",
    color: "bg-foreground-800",
    who: "普通网民 · 意见领袖 · 媒体",
    body: "最外层的舆论洋流，负责为事件定调、赋义并持续供给热度，也最容易在情绪中失真与撕裂。",
    impact: "范围最广，但密度随热度起伏",
  },
];

export interface Stage {
  phase: string;
  name: string;
  body: string;
  tone: string;
}

export const lifecycleStages: Stage[] = [
  {
    phase: "阶段一",
    name: "发酵潜伏",
    body: "信息在小圈层里流转，点赞寥寥，却已埋下引爆的火种。多数人此时毫无察觉。",
    tone: "quiet",
  },
  {
    phase: "阶段二",
    name: "集中爆发",
    body: "放大器集体按下，话题指数级扩散，讨论量在短时间内冲到峰值，铺天盖地。",
    tone: "hot",
  },
  {
    phase: "阶段三",
    name: "余波震荡",
    body: "真相逐步补位，阵营辩论、官方回应、二创跟进此起彼伏，热度从峰值回落但仍有反复。",
    tone: "wave",
  },
  {
    phase: "阶段四",
    name: "沉淀收束",
    body: "新热点分流注意力，事件转入后续问责与长尾讨论，最终沉淀为公共记忆或行业教训。",
    tone: "calm",
  },
];

export interface GuideCard {
  icon: string;
  title: string;
  body: string;
}

export const doGuides: GuideCard[] = [
  {
    icon: "ri-file-search-line",
    title: "先辨信源",
    body: "截图的出处、发布者身份、原帖是否被删除，先弄清楚“这句话到底是谁说的、有没有上下文”。",
  },
  {
    icon: "ri-time-line",
    title: "让子弹飞一会儿",
    body: "热度越高，反转概率越大。真正的结论往往要在各方陆续发声之后才逐渐清晰，别急着盖棺定论。",
  },
  {
    icon: "ri-shield-check-line",
    title: "只转可验证的信息",
    body: "对自己不确定的内容，先不转发、不站队。克制一次随手转发，可能就是少一次以讹传讹。",
  },
  {
    icon: "ri-book-open-line",
    title: "把个案放回系统看",
    body: "事件本身只是一环，背后的规则、惯例与结构更值得追问，也更有讨论价值。",
  },
];

export const donGuides: GuideCard[] = [
  {
    icon: "ri-scissors-2-line",
    title: "别断章取义",
    body: "掐头去尾只留最“炸”的一句，是最常见的失真方式。遇到冲击性内容，先找完整原话。",
  },
  {
    icon: "ri-emotion-sad-line",
    title: "别情绪绑架",
    body: "被愤怒带着走时，人会选择性忽略相反证据。允许自己先冷静，再判断是非。",
  },
  {
    icon: "ri-megaphone-line",
    title: "别做谣言的搬运工",
    body: "未经证实的劲爆消息最容易借你之手扩散。转发前先想一秒：我凭什么相信它？",
  },
  {
    icon: "ri-hashtag",
    title: "别把屏幕当刑场",
    body: "对素未谋面的当事人保持基本克制与尊重，娱乐可以，网暴不是“吃瓜”的延伸。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "一个热点为什么会突然“爆”？",
    a: "爆发通常是四股力量叠加的结果：内容足够有转发价值（可转发性）、戳中了大量人的共同情绪（情绪共振）、被多个放大器同时推送到公共视野（节点放大），再加上关键信息存在缺口而吊足胃口。单一因素很难真正引爆，多因素共振才容易形成我们常说的“瓜爆”。",
  },
  {
    q: "“连锁反应”和“波及面”是一回事吗？",
    a: "不太一样。波及面更像一张静止的地图，描绘事件影响到了哪些圈层——当事人、关联方、行业、公众舆论等；而连锁反应是动态的过程，讲的是这些圈层如何一个接一个被牵动、怎样发酵与蔓延。观察热点，两者通常要结合起来看。",
  },
  {
    q: "为什么有的热点很快就降温了？",
    a: "影响热度的因素很多：新热点分流了注意力、关键信息被迅速澄清、当事人的回应及时平息了情绪，或是话题本身缺乏持续讨论的“燃料”。热度本质是注意力的有限资源在竞争，降温不等于结束，常会转入长尾讨论。",
  },
  {
    q: "“余波”和“后续影响”有什么区别？",
    a: "余波侧重舆论层面——辩论、二创、扒旧账这些围绕话题的反复震荡；后续影响更侧重实质后果——合作解约、行业整改、规则调整、相关人员承担相应责任等。一个偏“谈资”，一个偏“后果”。",
  },
  {
    q: "瓜爆观察会报道具体新闻吗？",
    a: "我们不搬运或拼凑碎片化新闻，也不为博眼球制造对立。我们聚焦的是热点传播的规律本身：事件如何爆发、波及哪些层面、留下什么余波，并给读者提供判断方法。想知道“这件事发生了什么”，请以官方信源为准；想知道“这件事为什么传成这样”，可以看看我们的框架。",
  },
  {
    q: "热点观察的内容可信吗？",
    a: "我们坚持可验证原则：涉及事实的地方会标注信源与不确定性，涉及观点的地方会明确是分析而非定论。任何“观察”都欢迎你用事实去检验，一旦发现有误，也欢迎通过页面下方方式指出，我们会及时修正。",
  },
];

export const aboutPoints = [
  "不追时效，追规律",
  "不制造对立，只拆解机制",
  "事实与观点分开",
  "为读者提供可复用的判断力",
];